import { Component, CUSTOM_ELEMENTS_SCHEMA, HostBinding, Injector, NO_ERRORS_SCHEMA } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ServiceInjector } from './classes/infrastructure/injector';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Observable } from 'rxjs';
import { GlobalLoaderService } from './services/global_loader.service';
import { BreadcrumbAutoService } from './services/breadcrumb-auto.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // imports: [HttpClient, FormsModule, CommonModule],
  // schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
  // standalone: true,
})
export class AppComponent {
  currentUrl: string = '';
  loading$!: Observable<boolean>;

  @HostBinding('class') get getClass() {
    const sizeClassName = Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
    return `${sizeClassName} app`;
  }

  constructor(private authService: AuthService, private injector: Injector, private screen: ScreenService,
    public appInfo: AppInfoService, public router: Router, public loader: GlobalLoaderService, private breadcrumbAuto: BreadcrumbAutoService) {
    this.loading$ = this.loader.isLoading$;
    ServiceInjector.AppInjector = this.injector;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.urlAfterRedirects;
    });

    this.breadcrumbAuto.init();
  }

  isAuthenticated() {
    return this.authService.loggedIn;
  }

  isAuthPage(): boolean {
    return ['/Landing_Page', '/login-form', '/reset-password', '/create-account', '/forgot-password', '/create-new-password', '/otp-verification', '/Change_Password', '/privacy-policy', '/terms-conditions'].includes(this.currentUrl);
  }
}
